import { Component,
         OnInit } from '@angular/core';

@Component({
  selector: 'ss-form-separator',
  templateUrl: './form-separator.component.html',
  styleUrls: ['./form-separator.component.scss']
})
export class FormSeparatorComponent implements OnInit {

  // currentUser$: any
  // isLoggedIn: boolean

  constructor(
    // protected apiService: ApiService,
    // protected authService: AuthService
  ) { }

  ngOnInit(): void {
    // this.currentUser$ = this.currentUserStream()
  }


}
